import React, { Component } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { RouteComponentProps, withRouter } from "react-router-dom";
import LightModePageTemplate from "../page/Templates/LightModeTemplate";
import SideBarTemplate from "../side-bar/SideBarTemplate";
import LookupService from "../../services/LookupService";
import BulletinPanel from "../BulletinPanel/BulletinPanel";
import SimpleGridService from "../../services/SimpleGridService";
import { LoadIndicator } from "devextreme-react";
import ProviderCalendarPageSidebarPanel from "./ProviderCalendarPageSideBarPanel";
import ProviderCalendarGrid from "./ProviderCalendarGrid";
import sharedUtils from "../grid/sharedUtilities";

interface ProviderCalendarPageProps extends RouteComponentProps, WithTranslation {
    title: string;
    category: string;
    location: any;
    getBuild: (flag: boolean) => void;
}

interface ProviderCalendarPageState {
    providerId:string
    serviceTypeId: string;
    dateFrom: Date;
    clientStartDate: string;
    loadPanelVisible: boolean;
    applyButtonClicked: boolean;
    arrowButtonClicked: boolean;
    resetData: boolean;
}

class ProviderCalendarPage extends Component<ProviderCalendarPageProps> {
        conversionUtils: sharedUtils;
    state: ProviderCalendarPageState;
    SimpleGridService: SimpleGridService;
    lookupService: LookupService;

    constructor(props: ProviderCalendarPageProps) {
        super(props);
                this.conversionUtils = new sharedUtils();
        this.lookupService = new LookupService();
        this.SimpleGridService = new SimpleGridService();
        this.state = {
            providerId:"",
            serviceTypeId: "",
            dateFrom: new Date(),
            clientStartDate: this.conversionUtils.convertDateToString(new Date()),
            loadPanelVisible: false,
            applyButtonClicked: false,
            arrowButtonClicked: false,
            resetData: false
        };
    }
    componentDidUpdate(
        prevProps: Readonly<ProviderCalendarPageProps>,
        prevState: Readonly<ProviderCalendarPageState>,
    ): void {
        if (
            prevState.dateFrom != this.state.dateFrom
        ) {
            this.setState(
                {
                    clientStartDate: this.conversionUtils.convertDateToString(this.state.dateFrom),
                },
                () => {
                    if (this.state.arrowButtonClicked) {
                        this.setState({ applyButtonClicked: true });
                    }
                }
            );
        }
        if(prevProps.location.state.serviceTypeId != this.props.location.state.serviceTypeId && this.props.location.state.serviceTypeId){
            this.setState((prevState: ProviderCalendarPageState) => ({
                
                serviceTypeId: this.props.location.state.serviceTypeId,
                providerId: prevState.providerId ? prevState.providerId : "",
                dateFrom: new Date(),
                resetData: true,
            }))
        }
    }
    onApplyButtonClick = () => {
        this.setState({
            applyButtonClicked: true,
        });
    };

    setVenueId = (id: string) => {
        this.setState({ venueId: id });
    };
    setProviderId = (id: string) => {
        this.setState({ providerId: id });
    };
    setServiceTypeId = (id: string) => {
        this.setState({ serviceTypeId: id });
    };
    setDateFrom = (date: Date) => {
        this.setState({ dateFrom: date});
    };
    setApplyButtonClicked = (value: boolean) => {
        this.setState({ applyButtonClicked: value });
    };
    setArrowButtonClicked = (value: boolean) => {
        this.setState({ arrowButtonClicked: value });
    };
    setResetData = ()=>{
        this.setState({resetData:false})
    }
    render() {
        return (
            
            <LightModePageTemplate>
                <SideBarTemplate isFixed={true}>
                    <ProviderCalendarPageSidebarPanel
                        setServiceTypeId={this.setServiceTypeId}
                        serviceTypeId={this.state.serviceTypeId}
                        providerId={this.state.providerId}
                        setProviderId={this.setProviderId}
                        dateFrom={this.state.dateFrom}
                        setDateFrom={this.setDateFrom}
                        onApplyButtonClick={this.onApplyButtonClick}
                    />
                    <BulletinPanel />
                </SideBarTemplate>

                <div className="page-content--with-sidebar-hidden-mobile">
                    <header className="grid-info mt-3 mb-3">
                        <h2 className="page-title__black">Provider Calendar</h2>
                    </header>
                    {this.state.applyButtonClicked && (
                        <div className="starter-template">
                            <LoadIndicator
                                id="simple-grid-indicator"
                                height={100}
                                width={100}
                                visible={this.state.applyButtonClicked}
                            />
                        </div>
                    )}
                    <ProviderCalendarGrid
                        initialStart={this.state.clientStartDate}
                        serviceTypeId={this.state.serviceTypeId}
                        providerId={this.state.providerId}
                        applyButtonClicked={this.state.applyButtonClicked}
                        setApplyButtonClicked={this.setApplyButtonClicked}
                        setDateFrom={this.setDateFrom}
                        setArrowButtonClicked={this.setArrowButtonClicked}
                        resetData = {this.state.resetData}
                        setResetData = {this.setResetData}
                    />
                </div>
            </LightModePageTemplate>
        );
    }
}

export default withRouter(withTranslation()(ProviderCalendarPage) as React.ComponentType<any>);
